var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FolderListModel } from '../types/folder-list-model.interface';
import { FolderListApi } from '../types/folder-list-api.interface';
let FolderListServiceImpl = class FolderListServiceImpl {
    constructor(_folderListModel, _folderListApi) {
        this._folderListModel = _folderListModel;
        this._folderListApi = _folderListApi;
    }
    get folderList() {
        return this._folderListModel.folderList;
    }
    initFolderList(spaceId) {
        return this._folderListApi.getFolderListApi(spaceId).then((folderList) => {
            this._folderListModel.updateFolderList(folderList);
            return folderList;
        });
    }
    updateFolderList(folderList) {
        this._folderListModel.updateFolderList(folderList);
    }
    getFolderById(folderId) {
        return this._folderListModel.getFolderById(folderId);
    }
    updateFolderById(folderId, folder) {
        this._folderListModel.updateFolderById(folderId, folder);
    }
    addFolder(patentFolderId, folder) {
        this._folderListModel.addFolder(patentFolderId, folder);
    }
    deleteFolder(spaceId, folderId) {
        return this._folderListApi.deleteFolderApi(spaceId, folderId).then(res => {
            this._folderListModel.deleteFolder(folderId);
        });
    }
    sortFolder(spaceId, folderId, params) {
        return this._folderListApi.sortFolderApi(spaceId, folderId, params);
    }
    subscribe(callback) {
        return this._folderListModel.subscribe(callback);
    }
};
FolderListServiceImpl = __decorate([
    injectable(),
    __param(0, inject(FolderListModel)),
    __param(1, inject(FolderListApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof FolderListModel !== "undefined" && FolderListModel) === "function" ? _a : Object, typeof (_b = typeof FolderListApi !== "undefined" && FolderListApi) === "function" ? _b : Object])
], FolderListServiceImpl);
export { FolderListServiceImpl };
